import * as ReactDOM from 'react-dom/client';
import './i18n';
import { muiLicense } from '@diligentcorp/atlas-mui-license';
import './utils/supressWarnings';
import App from './app';

const PENDO_CLIENT_KEY = 'de9611a5-61a3-4d0e-715e-c618cdcb4269';

muiLicense.apply();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

function includePendo() {
  const pendoScript = document.createElement('script');
  pendoScript.innerText = `(function(apiKey){
    (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
    v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;w += 1)(function(m){
        o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
        y=e.createElement(n);y.async=!0;y.src='https://content.pendo.highbond.com/agent/static/'+apiKey+'/pendo.js';
        z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
})('${PENDO_CLIENT_KEY}');
// https://diligentbrands.atlassian.net/wiki/spaces/DPM/pages/3513583110/Pendo+Basic+Installation+Process
// https://app.pendo.io/s/5738959954247680/admin/app/-323232?tab=install`;
  document.head.appendChild(pendoScript);
}

includePendo();

root.render(<App />);
